import { render, staticRenderFns } from "./IPCallDetail.vue?vue&type=template&id=601eae72"
import script from "./IPCallDetail.vue?vue&type=script&lang=js"
export * from "./IPCallDetail.vue?vue&type=script&lang=js"
import style0 from "./IPCallDetail.vue?vue&type=style&index=0&id=601eae72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports